<template>
  <b-card class="no-border animated">
    <div class="item-header clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2">{{ header }}</h5>
    </div>
    <b-form @submit.prevent="onSubmit()">
      <fieldset class="form-group">
        <legend>Type</legend>
        <div class="form-row"
          :class="{'is-invalid': errors.has('user type'), 'no-border': !errors.has('user type')}">
          <!-- <legend class="col-form-legend col-sm-2">Employee type</legend> -->
          <div class="col-sm-10">
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input"
                  v-validate="'required'"
                  v-model="form.type"
                  type="radio"
                  name="user type"
                  value="LOADER" checked>
                <span :class="{'font-weight-bold': isLoader}">Loader</span>
                <small class="form-text text-muted">
                </small>
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input"
                  v-model="form.type"
                  type="radio"
                  name="user type"
                  value="DRIVER">
                <span :class="{'font-weight-bold': isDriver}">Driver</span>
                <small class="form-text text-muted">
                </small>
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input"
                  v-model="form.type"
                  type="radio"
                  name="user type"
                  value="OPERATOR">
                <span :class="{'font-weight-bold': isOperator}">Operator</span>
                <small class="form-text text-muted">
                </small>
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input"
                  v-model="form.type"
                  type="radio"
                  name="user type"
                  value="DEFAULT">
                <span :class="{'font-weight-bold': isRegular}">Regular</span>
                <small class="form-text text-muted">
                </small>
              </label>
            </div>
          </div>
        </div>
        <b-form-feedback>{{ errors.first('user type') }}</b-form-feedback>
      </fieldset>
      <legend>Detail</legend>
      <div class="form-row">
        <div class="form-group col-md-12">
          <label for="input_name">Name</label>
          <input type="text"
            name="name"
            v-validate="'required'"
            :class="{'is-invalid': errors.has('name')}"
            class="form-control"
            id="input_name"
            placeholder="Enter Name"
            v-model.trim="form.name">
          <b-form-feedback>{{ errors.first('name') }}</b-form-feedback>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="input_number">Number</label>
          <input type="text"
            name="number"
            v-validate="'numeric'"
            :class="{'is-invalid': errors.has('number')}"
            class="form-control"
            id="input_number"
            v-model.trim="form.number"
            placeholder="Enter number">
          <b-form-feedback>{{ errors.first('number') }}</b-form-feedback>
        </div>
        <div class="form-group col-md-6">
          <label>Company</label>
          <company-multi-select
            :multiple="false"
            having="self"
            :init-selection-id="employeeCompanyId"
            @on-selected="onCompanySelected"
            required
          />
        </div>
      </div>
      <legend v-if="isDriver">Fatigue Management</legend>
      <div v-if="isDriver" class="form-row">
        <div class="form-group col-md-6">
          <b-form-select
            v-model="form.fmType"
            :options="fatigueManageOptions"></b-form-select>
        </div>
      </div>
      <hr>
      <b-button
        type="submit"
        id="createBtn"
        :disabled="disabled"
        variant="primary">
        <span v-if="beforeClick">Save changes</span>
        <span v-else> Loading..</span>
        <i v-if="loadingSpinner" class="fa fa-spinner fa-spin"></i>
      </b-button>
      <b-button
        @click="onCancel()"
        type="reset"
        variant="outline-secondary"
        class="pull-right">Cancel</b-button>
    </b-form>
  </b-card>
</template>
<script>
import { isEmpty, get, isObject } from 'lodash';

import Multiselect from 'vue-multiselect';
import CompanyMultiSelect from '@/components/CompanyMultiSelect.vue';

export default {
  name: 'employee_detail',
  components: {
    Multiselect,
    CompanyMultiSelect,
  },
  data() {
    return {
      form: {
        id: null,
        name: '',
        number: null,
        type: 'DEFAULT',
        userId: null,
        company: null,
        fmType: null,
      },
      selectedCompany: null,
      dob: null,
      fatigueManageOptions: [
        { value: null, text: 'Select Type', disabled: true },
        { value: 'standard_solo', text: 'Standard Hours - Solo Driver' },
        { value: 'bfm_solo', text: 'BFM - Solo Driver' },
      ],
      loadingSpinner: false,
      beforeClick: true,
      disabled: false,
    };
  },
  created() {
    const { employeeId } = this.$route.params;
    const breadcrumb = [
      { to: '', name: 'Home' },
      { to: 'admin', name: 'Admin' },
      { to: 'employees', name: 'Employees' },
      { to: employeeId, name: 'Detail' },
      { to: 'edit', name: 'Edit' },
    ];

    if (!this.isEdit) {
      breadcrumb.splice(3, 2);
      breadcrumb.push({ to: 'create', name: 'Create' });
    }
    if (this.isEdit) {
      this.$store.commit('employees/SET_DETAIL_ID', employeeId);
      this.$store.dispatch('employees/LOAD_DETAIL_DATA');
    }
    this.$store.commit('SET_BREADCRUMB_ITEMS', breadcrumb);
  },
  computed: {
    detailedInfo() {
      const detailedInfo = this.isEdit
        ? this.$store.getters['employees/get_detail_data'] : {};
      return detailedInfo;
    },
    employeeCompanyId() {
      if (this.isEdit) {
        return get(this.detailedInfo, 'company.id', '');
      }
      return this.userData.company_id.toString();
    },
    displayName() {
      return this.detailedInfo.name;
    },
    header() {
      const header = this.isEdit
        ? `Edit Employee: ${this.displayName}`
        : 'Create New Employee';
      return header;
    },
    userData() {
      return this.$store.getters.userData;
    },
    isSystemAdmin() {
      const { userData } = this.$store.getters;
      return userData.type === 'SYSTEM_ADMIN';
    },
    isAdmin() {
      const { userData } = this.$store.getters;
      return userData.type === 'ADMIN';
    },
    isLoader() {
      return this.form.type === 'LOADER';
    },
    isDriver() {
      return this.form.type === 'DRIVER';
    },
    isOperator() {
      return this.form.type === 'OPERATOR';
    },
    isRegular() {
      return this.form.type === 'DEFAULT';
    },
    isEdit() {
      return !isEmpty(this.$route.params.employeeId);
    },
    isAddFrommSelectedCompany() {
      return !isEmpty(this.$route.params.companyId);
    },
    employeeType() {
      return this.form.type;
    },
  },
  watch: {
    detailedInfo(data) {
      const { form } = this;
      form.id = data.id;
      form.name = data.name;
      form.number = data.number;
      form.type = data.type;
      form.userId = this.userData.id;
      form.fmType = this.get(data, 'metadata.fatigue_management_type') || null;
    },
  },
  methods: {
    get(object, key) {
      return get(object, key) || '';
    },
    onSubmit() {
      const updateButtonState = (show = false) => {
        if (show) {
          this.loadingSpinner = true;
          this.beforeClick = false;
          this.disabled = true;
        } else {
          this.loadingSpinner = false;
          this.beforeClick = true;
          this.disabled = false;
        }
      };
      this.validate().then((valid) => {
        if (valid) {
          updateButtonState(true);
          let { employeeId } = this.$route.params;
          const { companyId } = this.$route.params;
          const action = this.isEdit ? 'UPDATE_DATA' : 'CREATE_DATA';

          this.$store.dispatch(`employees/${action}`, this.form).then((employee) => {
            if (companyId) {
              this.$router.push(`/admin/companies/${companyId}/employees`);
            } else {
              employeeId = this.isEdit ? employeeId : employee.id;
              // if (employee.type === 'DRIVER') {
              //   if (employee.company.id !== this.userData.company_id) {
              //     this.$router.push(`/admin/employees/${employeeId}`);
              //     if (employee.company.type !== 'TRANSPORTER') employeeId = '';
              //   }
              // }
              this.$router.push(`/admin/employees/${employeeId}`);
            }
            updateButtonState();
          });
        }
      });
    },
    validate() {
      return this.$validator.validateAll();
    },
    onCancel() {
      const { employeeId, companyId } = this.$route.params;
      if (this.isEdit) {
        this.$router.push(`/admin/employees/${employeeId}`);
      } else if (companyId) {
        this.$router.push(`/admin/companies/${companyId}/employees`);
      } else {
        this.$router.push('/admin/employees');
      }
    },
    onCompanySelected(company) {
      if (isObject(company)) {
        this.form.company = company;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/admin/employees/CreateEdit.vue